import styled from 'styled-components';
import { Color, Spacing, media, padding } from '../../../../../theme';
const rowHeight = '2.5rem';
export const DataTableBodyRow = styled('tr') `
  width: 100%;

  ${(p) => p.isClickable && 'cursor: pointer;'}

  &:last-child td:last-child {
    border-bottom: none;
  }

  ${(props) => media.up('md') `
    height: ${rowHeight};

    &:last-of-type td {
      border-bottom: none;
    }

    &:nth-child(even) {
      background-color: ${props.theme.colors.light || Color.LIGHT};
    }

    &:nth-child(odd) {
      background-color: ${Color.WHITE};
    }
  `}
`;
export const DataTableCell = styled('td') `
  border-right: 1px solid ${Color.GRAY_300};
  border-bottom: 1px solid ${Color.GRAY_300};

  &:last-of-type {
    border-right: none;
  }

  ${media.down('sm') `
    ${padding.all('small')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: right;
    min-height: ${rowHeight};
    border-right:none;

    &:first-of-type{
      font-weight: bold;
      text-align:left;
      background-color: ${Color.GRAY_200};
    }

    :not(:first-of-type){
      &::before {
        text-align: left;
        font-weight: bold;
        content: attr(data-heading);
        max-width: 50%;
        }
    }

   
  `}

  ${(props) => media.up('md') `
    padding: 0.5rem;
    vertical-align: middle;
    text-align: ${props.align ? props.align : 'left'};
  `}
`;
export const DataTableBodyRowNoData = styled('tr') `
  width: 100%;
`;
export const DataTableCellNoData = styled('td') `
  text-align: center;
  border-top: 1px solid ${Color.GRAY_200};
  padding: ${Spacing.L};
`;
//# sourceMappingURL=data-table-body.styles.js.map